export default __webpack_public_path__ + "static/media/microsoft-logo.bea1f1b4.svg";